<template>
  <v-container>
    <h3>
      最近作った会話デッキ
      <span class="subtitle-1">(*ブラウザのキャッシュを削除すると消えます)</span>
    </h3>

    <DeckList :decks="decks" @select-deck="selectDeck($event)" />
  </v-container>
</template>

<script>
// @ is an alias to /src
import DeckList from "@/components/DeckList.vue";
import { KaiwaDeck } from "@/models/KaiwaDeck";

import { mapGetters } from "vuex";
import router from "@/router";

export default {
  name: "RecentlyCreatedDecks",
  components: {
    DeckList,
  },
  computed: {
    ...mapGetters("draftDeck", {
      decks: "getCreatedDecks",
    }),
  },
  created() {
    this.$store.dispatch("draftDeck/fetchCreatedDecks");
  },
  methods: {
    selectDeck(deck) {
      router.push({ path: `/decks/${deck.deckId}` });
    },
  },
};
</script>
